import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface INoOpRequest extends IBaseRequest {

}

export class NoOpRequest extends BaseRequest implements INoOpRequest {

  public toXml(): string {
    return super.wrapperXml("NoOp", super.toXml());
  }
}
